import React from 'react'
import { Chip, Skeleton, useTheme } from '@mui/material'
import { getSgReadyStatusBadges } from '../consts'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { EmsSgReadyMode } from 'src/Libs/dynamic-power-prices/types'

/**
 * This component is a Badge/Chip for the SG-Ready status that is used in AI360°. It has multiple states/options.
 */
const SgReadyBadge: React.FC<{ status: EmsSgReadyMode | null; isLoading?: boolean }> = ({ status, isLoading }) => {
  const { t } = useCustomTranslation()
  const theme = useTheme()
  const statusBadge = getSgReadyStatusBadges(theme).find(badge => badge.status === status)

  if (isLoading) return <Skeleton variant="text" sx={{ minWidth: 120, minHeight: 20, borderRadius: '16px' }} />
  return <Chip sx={{ backgroundColor: statusBadge?.color, color: statusBadge?.textColor }} label={t(statusBadge?.label ?? '')} size="small" />
}

export default SgReadyBadge
